"use strict";

module.exports = function () {
	require("/Users/serg/projects/gpn-prod/frontend/components/core/core.js");
require("/Users/serg/projects/gpn-prod/frontend/components/layout/layout.js");
require("/Users/serg/projects/gpn-prod/frontend/components/navigation/navigation.js");
require("/Users/serg/projects/gpn-prod/frontend/components/filters/filters.js");
require("/Users/serg/projects/gpn-prod/frontend/components/component/component.js");


require("/Users/serg/projects/gpn-prod/frontend/components/news/news.js");
require("/Users/serg/projects/gpn-prod/frontend/components/noty/noty.js");
require("/Users/serg/projects/gpn-prod/frontend/components/files-upload/files-upload.js");
require("/Users/serg/projects/gpn-prod/frontend/components/forms/forms.js");


require("/Users/serg/projects/gpn-prod/frontend/components/slider/slider.js");
require("/Users/serg/projects/gpn-prod/frontend/components/mobile-apps/mobile-apps.js");
require("/Users/serg/projects/gpn-prod/frontend/components/modal/modal.js");
require("/Users/serg/projects/gpn-prod/frontend/components/popup/popup.js");
require("/Users/serg/projects/gpn-prod/frontend/components/animation/animation.js");

require("/Users/serg/projects/gpn-prod/frontend/components/tippy/tippy.js");

require("/Users/serg/projects/gpn-prod/frontend/components/counters/counters.js");
require("/Users/serg/projects/gpn-prod/frontend/components/pickaday/pickaday.js");
require("/Users/serg/projects/gpn-prod/frontend/components/search-page/search-page.js");
require("/Users/serg/projects/gpn-prod/frontend/components/tabs-accordions/tabs-accordions.js");
require("/Users/serg/projects/gpn-prod/frontend/components/page-banner/page-banner.js");
require("/Users/serg/projects/gpn-prod/frontend/components/page-nav/page-nav.js");
require("/Users/serg/projects/gpn-prod/frontend/components/collapsed/collapsed.js");
require("/Users/serg/projects/gpn-prod/frontend/components/iframe/iframe.js");
require("/Users/serg/projects/gpn-prod/frontend/components/zoom-img/zoom-img.js");
require("/Users/serg/projects/gpn-prod/frontend/components/main-page/main-page.js");

require("/Users/serg/projects/gpn-prod/frontend/components/subscribtion/subscribtion.js");
require("/Users/serg/projects/gpn-prod/frontend/components/cookies-panel/cookies-panel.js");
require("/Users/serg/projects/gpn-prod/frontend/components/eval-popup/eval-popup.js");
require("/Users/serg/projects/gpn-prod/frontend/components/sticky-sidebar/sticky-sidebar.js");
require("/Users/serg/projects/gpn-prod/frontend/components/filters-list/filters-list.js");

require("/Users/serg/projects/gpn-prod/frontend/components/hero-slider/hero-slider.js");
require("/Users/serg/projects/gpn-prod/frontend/components/spoiler/spoiler.js");
require("/Users/serg/projects/gpn-prod/frontend/components/select/select.js");
require("/Users/serg/projects/gpn-prod/frontend/components/proneft-search/proneft-search.js");
require("/Users/serg/projects/gpn-prod/frontend/components/ecoinform/ecoinform.js");
require("/Users/serg/projects/gpn-prod/frontend/components/detail-share/detail-share.js");;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/callback-loader/callback-loader.js!./node_modules/babel-loader/lib?{"cacheDirectory":"cache","presets":["es2015"],"plugins":["transform-es3-member-expression-literals","transform-es3-property-literals","transform-object-rest-spread"]}!./frontend/components.js
// module id = 40
// module chunks = 0